export enum AddUserApiErrors {
  AddUserFailure = 'Add user failure.',
  DeleteUserFailure = 'Delete user failure.',
  EmailAlreadyExists = 'User email already exists.',
  EmailIsReserved = 'User email is reserved.',
  InvalidSender = 'Invalid sender.',
  InvalidUser = 'Invalid user.',
  InvalidUserBody = 'Invalid user body.',
  InvalidUserEmail = 'Invalid user email.',
  InvalidUserId = 'Invalid user ID.',
  InvalidUserName = 'Invalid user name.',
  InvalidUserRole = 'Invalid user role.',
  NotFoundUsers = 'Users not found.',
  UpdateUserFailure = 'Update user failure.'
}

export enum AddDomainApiErrors {
  AddDomainFailure = 'Add domain failure.',
  DeleteDomainFailure = 'Delete domain failure.',
  DomainNameAlreadyExists = 'Domain name already exists.',
  DomainNameIsReserved = 'Domain name is reserved.',
  GetDomainsFailure = 'Get domains failure.',
  InvalidDomain = 'Invalid domain.',
  InvalidDomainBody = 'Invalid domain body.',
  InvalidDomainId = 'Invalid domain ID.',
  InvalidDomainName = 'Invalid domain name.',
  InvalidDomainRole = 'Invalid domain role.',
  UpdateDomainFailure = 'Update domain failure.'
}

export enum GeneralErrors {
  Unauthorized = 'Unauthorized.',
  Forbidden = 'Forbidden.',
  InvalidBotId = 'Invalid bot ID.',
  InvalidBotApiKey = 'Invalid bot API key.',
  InvalidBotApiUrl = 'Invalid bot API URL.',
  InvalidHostingConfig = 'Invalid hosting configuration.',
  UnsavedBotChanges = 'Unsaved bot changes.',
  ServiceUnavailable = 'Service Unavailable.',
  UnsavedBotTestEnvironmentChanges = 'Unsaved bot test environment changes.'
}

export enum NlpErrors {
  ModelNotFound = 'NLP model not found.',
  InvalidModelId = 'Invalid NLP model ID.',
  InvalidDocumentId = 'Invalid document ID.'
}
